import { Grid, Skeleton } from '@mui/material';

type ProductGridSkeletonProps = {
  numberOfSkeletons?: number;
};
export default function ProductGridSkeleton({
  numberOfSkeletons = 9,
}: ProductGridSkeletonProps) {
  return (
    <Grid container width="100%" rowSpacing={2} columnGap={1} pl={0.5}>
      {Array.from({ length: numberOfSkeletons }).map((_, i) => (
        <Grid
          item
          xs={3.8}
          sm={2.85}
          md={2.3}
          key={`skeleton-${i}`}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Skeleton
            variant="rectangular"
            animation="wave"
            width="100%"
            height={100}
          />
          <Skeleton width="80%" animation="wave" />
          <Skeleton width="60%" animation="wave" />
          <Skeleton sx={{ mt: 4 }} width="40%" animation="wave" />
        </Grid>
      ))}
    </Grid>
  );
}
